import { QueryClient } from '@tanstack/react-query';

export const publicDirectoryCache = {
  staleTime: 5 * 60 * 1000,
  refetchOnWindowFocus: false,
} as const;

export const adminDashboardCache = {
  staleTime: 30 * 1000,
  refetchOnWindowFocus: false,
} as const;

export const ADMIN_CACHED_KEYS = ['admin-tools', 'admin-submissions', 'admin-users', 'tool-analytics', 'daily-trends', 'ownership-history', 'platform-stats'] as const;

// Only explicitly public families receive these defaults; account/admin queries
// retain TanStack's immediate freshness and focus-refetch behavior.
export function createAppQueryClient() {
  const client = new QueryClient();
  for (const key of ['tools', 'tool', 'skills-public', 'skill-public', 'skill-categories-public']) {
    client.setQueryDefaults([key], publicDirectoryCache);
  }
  // Admin lists: short 30s cache so revisiting a section shows cached data;
  // roles/permissions, payments and credits keep default freshness.
  for (const key of ADMIN_CACHED_KEYS) client.setQueryDefaults([key], adminDashboardCache);
  // Moderation and owner edits already invalidate these source families. Mark
  // the corresponding public caches stale as well, without delaying mutations.
  client.getQueryCache().subscribe(event => {
    if (event.type !== 'updated' || event.action.type !== 'invalidate') return;
    const key = event.query.queryKey[0];
    const targets = key === 'admin-tools' ? ['tools', 'tool']
      : key === 'tools' ? ['tool']
      : key === 'admin-skills' ? ['skills-public', 'skill-public']
      : key === 'skill-categories' ? ['skill-categories-public'] : [];
    for (const target of targets) void client.invalidateQueries({ queryKey: [target] });
  });
  return client;
}